import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Suggestion } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class SuggestionModule extends VuexModule {
    @Action
    [Suggestion.findPageSuggestion](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/suggestion/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Suggestion.saveSuggestion](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/suggestion/update`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Suggestion.deleteSuggestion](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/suggestion/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}